<template>
  <div>
    <br>
    <Payment-Cards-Card/>
  </div>
</template>

<script>
export default {
  
}
</script>

<style>

</style>